<template lang="pug">
#comparison
  .compare
    TransitionFade
      AppLoader(v-if="status.loading || status.error" key="loader")
      .compare__grid(v-else ref="grid" key="grid")
        AppProducts
        AppDetails(v-for="spec in specs", :key="spec", :spec="spec", :label="specLabels[spec]")
</template>

<script>
import TransitionFade from './transitions/Fade.vue'
import AppLoader from './components/Loader.vue'
import AppProducts from './components/Products.vue'
import AppDetails from './components/Details.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    AppLoader,
    AppProducts,
    AppDetails,
    TransitionFade,
  },
  data() {
    return {
      loader: null,
    }
  },
  computed: {
    ...mapGetters(['status', 'specs', 'specLabels']),
  },
  methods: {
    ...mapMutations(['removeComparison']),
    ...mapActions(['fetchData', 'initialize']),
  },
  created() {
    let endpoint = this.$root.src + '?filter=' + this.$root.filter
    this.loader = this.fetchData(endpoint)
  },
  async mounted() {
    await this.loader
    if (this.status.error) return
    let initial = window.matchMedia('(min-width: 768px)').matches ? 3 : 2
    let grid = this.$refs.grid
    this.initialize({ initial, grid })
  },
}
</script>

<style lang="scss">
html {
  font-size: $rootEM;
}
</style>
<style lang="scss" scoped>
.compare {
  @include container($max: 1400px, $margin: 16px);
  padding-top: 3rem;
  padding-bottom: 3rem;
  position: relative;

  @include mqdn(md) {
    margin: 0;
  }

  &__grid {
    display: grid;
    grid-template-columns: min-content 1fr;
    grid-auto-rows: auto;
    max-width: 100%;

    @include mq(md) {
      grid-template-columns: auto 1fr;
    }
  }
}
</style>
